import Tabs from '@cloudscape-design/components/tabs';
import Container from '@cloudscape-design/components/container';
import Header from '@cloudscape-design/components/header';
import SpaceBetween from '@cloudscape-design/components/space-between';
import Alert from '@cloudscape-design/components/alert';
import Badge from '@cloudscape-design/components/badge';
import Box from '@cloudscape-design/components/box';
import Button from '@cloudscape-design/components/button';
import Link from '@cloudscape-design/components/link';
import Table from '@cloudscape-design/components/table';

const mockMembers = [
  { alias: 'vjjoseph', name: 'Vinu Joseph', role: 'Admin', lastAccess: '2 hours ago' },
  { alias: 'chohasin', name: 'Chohasin Ahmed', role: 'Member', lastAccess: '1 day ago' },
  { alias: 'gakhar', name: 'Priya Gakhar', role: 'Member', lastAccess: '3 hours ago' },
  { alias: 'dramaswa', name: 'Dinesh Ramaswamy', role: 'Read Only', lastAccess: '5 days ago' },
];

export default function SettingsView() {
  return (
    <SpaceBetween size="l">
      <Header variant="h1">Settings</Header>
      <Tabs
        tabs={[
          {
            label: 'Members',
            id: 'members',
            content: (
              <SpaceBetween size="l">
                <Alert type="info" header="Access is managed via Helix LDAP POSIX groups">
                  <SpaceBetween size="s">
                    <Box>To grant a user access to this mailbox, add them to the appropriate POSIX group in Helix:</Box>
                    <div
                      style={{
                        fontFamily: 'monospace',
                        fontSize: '13px',
                        backgroundColor: '#f8f9fa',
                        padding: '12px',
                        borderRadius: '6px',
                      }}
                    >
                      <div>
                        <strong>Admin:</strong> mailhub-freight-ops-admin
                      </div>
                      <div>
                        <strong>Member:</strong> mailhub-freight-ops-member
                      </div>
                      <div>
                        <strong>Read-only:</strong> mailhub-freight-ops-readonly
                      </div>
                    </div>
                    <Link href="https://helix.amazon.com" external>
                      Manage groups in Helix →
                    </Link>
                  </SpaceBetween>
                </Alert>
                <Table
                  header={<Header variant="h3">Current Members</Header>}
                  columnDefinitions={[
                    { id: 'name', header: 'Name', cell: (item) => item.name },
                    { id: 'alias', header: 'Alias', cell: (item) => `${item.alias}@` },
                    {
                      id: 'role',
                      header: 'Role',
                      cell: (item) => {
                        const color = item.role === 'Admin' ? 'blue' : item.role === 'Member' ? 'green' : 'grey';
                        return <Badge color={color}>{item.role}</Badge>;
                      },
                    },
                    { id: 'lastAccess', header: 'Last Active', cell: (item) => item.lastAccess },
                  ]}
                  items={mockMembers}
                />
              </SpaceBetween>
            ),
          },
          {
            label: 'Domain',
            id: 'domain',
            content: (
              <Container header={<Header variant="h3">Verified Domain</Header>}>
                <SpaceBetween size="m">
                  <div>
                    <Box variant="awsui-key-label">Receiving Domain</Box>
                    <Box>freight-ops@amazon.com</Box>
                  </div>
                  <div>
                    <Box variant="awsui-key-label">SES Verification Status</Box>
                    <Badge color="green">Verified ✓</Badge>
                  </div>
                  <div>
                    <Box variant="awsui-key-label">MX Record</Box>
                    <Box fontWeight="normal" variant="code">
                      10 inbound-smtp.us-west-2.amazonaws.com
                    </Box>
                  </div>
                </SpaceBetween>
              </Container>
            ),
          },
          {
            label: 'Danger Zone',
            id: 'danger',
            content: (
              <Container header={<Header variant="h3">Danger Zone</Header>}>
                <SpaceBetween size="l">
                  <Alert type="warning">These actions are destructive and cannot be undone.</Alert>
                  <SpaceBetween direction="horizontal" size="s">
                    <Button variant="normal">Delete All Emails</Button>
                    <Button variant="normal">Delete Mailbox</Button>
                  </SpaceBetween>
                </SpaceBetween>
              </Container>
            ),
          },
        ]}
      />
    </SpaceBetween>
  );
}
